
export default {
  auth: {},
  user: {},
  postedSchedules: {},
  listPostedSchedules: {},
  listPreviousPostings: {},
  liveSchedules: {},
  listResourceCollections: {},
  listMyQuickSchedules: {},
  myQuickSchedules: [],
  resources: {},
  selectedResource: {
    id: '',
    name: ''
  },
  selectedDayTypeResource: {
    id: '',
    name: ''
  },
  selectedResourceCollection: {
    name: '',
    id: '',
    key: ''
  },
  detailedSchedules: {
    startDate: '',
    endDate: '',
    detailedSchedules:[]
  },
  dayTypeCalendar: {},
  dayTypeSecurity: {},
  editMode: { status: false },
  createTourPreReq: {},
  resourceDayType: {},
  tour: {},
  meal: {},
  dayTypesAll: {},
  dayTypesAllWithoutForceTour: {},
  liveScheduleOptimisticReRender: { status: false },
  liveScheduleOptimisticSchedule: [],
  resourcePersonnelData: {},
  dayType: {},
  dayTypeRequestsByYear: {},
  dayTypeRequestById: [],
  navigation: {
    hamburgerMenu: false
  },
  postingScheduleObject: { success: false, message: ''},
  branch: {},
  relevantJobs: {},
  costObjects: {},
  relevantJobsForCostObject: {},
  relatedBranches: {},
  groupsByBranchAndResource: {},
  servicesByDate: {},
  activityTypes: {},
  serviceSalaryLevel: {},
  servicePrimaryRate: {},
  serviceJobSalaries: {},
  logJobStartRecord: {},
  logJobFinishRecord: {},
  job: {},
  jobElement: {},
  activeTours: {},
  defaultTourLength: {},
  validateEmptyJob: {},
  costObject: {},
  jobElementsWithDetails: {},
  groupsByBranchInCompany: {},
  service: {},
  assignmentServicesByGroup: {},
  servicesByGroup: {},
  updatingUser: {},
  updateUserHistoryRecord: {},
  resourceByDates: {},
  jobElements: {},
  approvedJobElements: {},
  resourceCollectionInformation: {
    id: 0,
    name: ''
  },
  detailedScheduleUpdateObject: { status: false, message: '' },
  tourApprovals: {
    data: []
  },
  timeKeeperCheckForTour: {
    data: 0
  },
  tourIsDirectBilling: {
    data: ''
  },
  contactInfoForAssignment: {
    data: 0
  },
  tourReversal: {
    status: ''
  },
  approvalParameters: {
    fromDate: '',
    tillDate: '',
    branchId: 0,
    divisionId: 0,
    departmentId: 0,
    by: 2,
    rcId: 0,
    filter: '',
    orderBy: 2,
    jobId: 0,
    resourceId: 0,
    userId: 0,
    showAssignments: false,
    orderByDep: false,
    clientId: 0,
    projectId: 0,
    showDayTypes: false,
    costObjectId: 0,
    costObjectTypeId: 0,
  },
  tourActivityFlag: {},
  tourActivityFlags: {},
  tourIndicators: {},
  tourPayTransaction: {},
  tourPayTransactions: {},
  activityFlagByTour: {},
  codesByIndicator: {},
  indicatorsById: {},
  indicatorsByTour: {},
  jobElementsByTour: {},
  tourMeals: {},
  payTransactionsByTour: {},
  tourIndicator: {},
  branchesByCompanyId: {
    data: []
  },
  divisionsByBranchId: {
    data: []
  },
  departmentsByCompanyIdBranchIdDivisionId: {
    data: []
  },
  resourceContactInfo: {
    data: []
  },
  dayTypesByDayRule: {
    dayTypes: []
  },
  dayTypesAllowingTourScheduling: {
    dayTypes: []
  },
  ifToursAreInDateRange: {
    data: []
  },
  postedScheduleParameters: {
    postedId: 0,
    resourceId: 0,
    resourceName: '',
    scheduleFormat: 1,
    startDate: '',
  },
  detailedScheduleParameters: {
    detailedStartDate: '',
    detailedEndDate: ''
  },
  liveScheduleParameters: {
    startDate: '',
    scheduleFormat: 1,
    resourceCollectionName: '',
    resourceCollectionId: 0
  },
  dayTypeCalendarScheduleParameters: {
    startDate: {}
  },
  ifHasHolidaySchedule: {hasHolidaySchedule:false}
};



// WEBPACK FOOTER //
// ./src/redux/reducers/initialState.js